export const Intentions = {
    FillLookup: 'FillLookup',
    MakeBackLink: 'MakeBackLink'
};